export default __webpack_public_path__ + "static/kontaktdaten-11efa9a8927e64f0fbaf3e708d68248f.png";